import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../model/widget.model';

@Component({
    selector: 'app-crm-task-filter-widget',
    templateUrl: './crm-task-filter-widget.component.html',
    styleUrl: './crm-task-filter-widget.component.scss',
})
export class AppCrmTaskFilterWidgetComponent {
    @Input() widgetData: WidgetModel;
}
